// extracted by mini-css-extract-plugin
export var card = "_jo-5";
export var cardSelected = "_jo-4";
export var image = "_jo-3";
export var modal = "_jo-0";
export var modalContent = "_jo-1";
export var table = "_jo-2";